"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_actions_1 = require("redux-actions");
var Types_1 = require("./Types");
exports.changeBreadCrumbActionWithOptions = redux_actions_1.createAction(Types_1.CHANGE_BREADCRUMB, function (items, options) {
    return __assign({ pageBreadcrumbItems: items }, options);
});
exports.changeBreadCrumbAction = redux_actions_1.createAction(Types_1.CHANGE_BREADCRUMB, function (items) {
    return { pageBreadcrumbItems: items,
        maxDisplayedItems: undefined,
        overflowIndex: undefined
    };
});
//# sourceMappingURL=Action.js.map